/**
 * PATH: packages/pricelist/src/workbookStyles.ts
 * FILE_ID: PKG-PRICELIST-STYLES-001
 * PURPOSE: Scoped CSS for the pricelist workbook chrome (qb-pl-* classes:
 *          toolbar buttons, supplier select, computed/draft/new row tints,
 *          and the delete + pick action buttons). Extracted from
 *          PricelistWorkbook so that file stays under the 300-line cap.
 */
export const WORKBOOK_STYLES = `
.qb-pl-btn{display:inline-flex;align-items:center;gap:.4rem;border-radius:.5rem;border:1px solid rgb(203 213 225);padding:.4rem .7rem;font-size:.8rem;color:rgb(51 65 85);background:white}
.qb-pl-btn:hover{background:rgb(248 250 252)}
.qb-pl-btn-primary{display:inline-flex;align-items:center;gap:.4rem;border-radius:.5rem;padding:.4rem .8rem;font-size:.8rem;font-weight:600;color:white;background:rgb(5 150 105)}
.qb-pl-btn-primary:hover{background:rgb(4 120 87)}
.qb-pl-btn-primary:disabled{opacity:.5}
.qb-pl-toolbar--phone{gap:.5rem}
.qb-pl-toolbar--phone .qb-pl-btn,.qb-pl-toolbar--phone .qb-pl-btn-primary{min-height:44px;min-width:44px;padding:.65rem .9rem;font-size:.875rem}
@media (max-width:767px){
  .qb-pl-btn,.qb-pl-btn-primary{min-height:44px;min-width:44px;padding:.65rem .9rem}
  .qb-pl-select{min-height:44px}
}
.qb-pl-select{border-radius:.4rem;border:1px solid rgb(203 213 225);padding:.25rem .5rem;font-size:.78rem;background:white;color:rgb(51 65 85)}
.qb-pl-computed{background:rgba(16,185,129,.07);font-style:italic}
.qb-pl-draft{background:rgba(245,158,11,.10)}
.qb-pl-new{background:rgba(59,130,246,.08)}
.qb-pl-del-btn{display:inline-flex;align-items:center;justify-content:center;width:22px;height:22px;border-radius:.35rem;border:0;background:transparent;color:rgb(148 163 184);font-size:16px;line-height:1;cursor:pointer}
.qb-pl-del-btn:hover{background:rgba(239,68,68,.12);color:rgb(220 38 38)}
.qb-pl-pick-btn{display:inline-flex;align-items:center;justify-content:center;width:24px;height:22px;border-radius:.35rem;border:0;background:rgba(5,150,105,.10);color:rgb(5 150 105);font-size:15px;line-height:1;cursor:pointer}
.qb-pl-pick-btn:hover{background:rgba(5,150,105,.22)}
.qb-pl-overflow-btn{display:inline-flex;align-items:center;justify-content:center;width:28px;height:28px;border-radius:.4rem;border:0;background:transparent;color:rgb(100 116 139);font-size:18px;line-height:1;cursor:pointer;opacity:0;pointer-events:none}
.ag-row-hover .qb-pl-overflow-btn,.ag-row-focus .qb-pl-overflow-btn,.ag-row-selected .qb-pl-overflow-btn{opacity:1;pointer-events:auto}
.qb-pl-overflow-btn:hover{background:rgba(148,163,184,.18);color:rgb(51 65 85)}
@media (max-width:767px){
  .qb-pl-overflow-btn{opacity:1;pointer-events:auto;min-width:44px;min-height:44px;width:44px;height:44px}
}
.qb-pl-align-center{text-align:center}
.qb-pl-align-center .ag-header-cell-label{justify-content:center}
.qb-pl-align-right{text-align:right}
.qb-pl-align-right .ag-header-cell-label{justify-content:flex-end}
`
